import React from 'react';
import SrText from 'client/components/SrText';
import PropTypes from 'prop-types';
import SrBox from 'client/components/SrBox';
import {
  SR_BUTTON_THEME_ADOBE_YELLOW,
  SR_BUTTON_THEME_ADOBE_GREY,
} from 'client/components/SrButton/SrButton';
import SrSimpleMessageModal, {
  SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP,
} from 'client/components/SrSimpleMessageModal/SrSimpleMessageModal';

const SrUtilityDisableInternetConfirmationModal = ({ closeModal, modalArgs }) => {
  return (
    <SrSimpleMessageModal
      iconUrl="/images/emoji-warning.png"
      theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
      contentContainerClassName="utilityProviderContact"
      iconBgColor="#FFFBEB"
      maxWidth="320px"
      maxIconHeight="100px"
      maxIconWidth="100px"
      headline={
        <SrBox maxWidth="280px" margin="0 auto">
          <SrText fontSize="24px" weight="800" font="greycliff" display="block">
            Internet is already a non-required utility.
          </SrText>
        </SrBox>
      }
      underline
      message={
        <SrBox maxWidth="280px" margin="0 auto">
          <SrText fontSize="16px" font="greycliff" display="block">
            When enabled, renters can choose to purchase internet through the platform, earning you
            additional revenue!
          </SrText>
          <SrText fontSize="16px" font="greycliff" paddingTop="20px" display="block" align="center">
            <SrText weight="bold">Pro Tip:</SrText> Only disable the internet if it is already
            included in the rent.
          </SrText>
        </SrBox>
      }
      srMultiButtons={[
        {
          buttonText: 'Remove Internet Options',
          onButtonClick: () => {
            modalArgs.handleConfirmation();
            closeModal();
          },
          buttonTheme: SR_BUTTON_THEME_ADOBE_YELLOW,
        },
        {
          buttonText: 'Cancel',
          onButtonClick: closeModal,
          buttonTheme: SR_BUTTON_THEME_ADOBE_GREY,
        },
      ]}
    />
  );
};

SrUtilityDisableInternetConfirmationModal.propTypes = {
  closeModal: PropTypes.func,
  modalArgs: PropTypes.shape({
    handleConfirmation: PropTypes.func,
  }),
};

SrUtilityDisableInternetConfirmationModal.displayName = 'SrUtilityDisableInternetConfirmationModal';
export default SrUtilityDisableInternetConfirmationModal;
